export const en = {
  nav: {
    home: 'Home',
    courses: 'Courses',
    about: 'About',
    faq: 'FAQ',
    contact: 'Contact'
  },
  hero: {
    badge: 'Premium Crypto Education',
    title: 'Become a Master of',
    titleHighlight: 'Cryptocurrency',
    subtitle: 'Learn cryptocurrency trading and blockchain technology from practicing industry experts',
    ctaPrimary: 'Choose Course',
    ctaSecondary: 'Free Consultation',
    stats: {
      students: '150+ Students',
      programs: '12+ Programs',
      experience: '8 Years Experience',
      support: 'Online Support'
    }
  },
  courses: {
    title: 'Our Courses',
    subtitle: 'Choose the program that fits your experience level',
    levels: {
      beginner: 'Beginner',
      intermediate: 'Intermediate',
      advanced: 'Advanced',
      professional: 'Professional',
      elite: 'Elite',
      master: 'Master',
      guru: 'Guru',
      legend: 'Legend'
    },
    duration: 'Duration',
    practice: 'Practice',
    certificate: 'Certificate',
    mentorship: 'Mentorship',
    community: 'Community Access',
    lifetime: 'Lifetime Access',
    cta: 'Learn More',
    buy: 'Buy Course',
    badge: 'Educational Programs',
    headingChoose: 'Choose',
    headingPath: 'your path',
    count: '{{current}} / {{total}} courses',
    items: [
      {
        id: 10,
        name: 'Crypto Intro',
        price: 100,
        level: 'beginner',
        duration: '1 week',
        practice: '5 hours',
        description: 'The lowest entry point into crypto. Understand what Bitcoin is and how to safely buy your first coin.',
        fullDescription: `Crypto Intro is the most affordable starting point for those who have only heard about cryptocurrency but haven't figured out where to begin.

In one week, you'll get a clear picture of the market without terminology overload or complex strategies.

What you will get:
• Understanding of cryptocurrency and blockchain
• Overview of major coins: Bitcoin, Ethereum, USDT
• Step-by-step exchange registration guide
• Your first crypto purchase without mistakes
• Basic account and wallet protection

Course Program:
1. What is cryptocurrency — explained simply
2. Bitcoin and Ethereum: what's the difference
3. How to choose an exchange and pass verification
4. First purchase: step-by-step walkthrough
5. Basic security: passwords, 2FA, phishing
6. Common beginner mistakes and how to avoid them`,
        features: [
          'Concise format, no fluff',
          'Access to beginner chat'
        ]
      },
      {
        id: 11,
        name: 'Crypto Base',
        price: 200,
        level: 'beginner',
        duration: '10 days',
        practice: '8 hours',
        description: 'Extended basics: wallets, exchanges, first trades, and basic chart analysis.',
        fullDescription: `Crypto Base is the next step after getting familiar with the market. A course for those who want to work confidently with cryptocurrency on their own.

You won't just buy your first coin — you'll learn to store assets, read charts, and avoid typical traps.

What you will get:
• Setting up and securing crypto wallets
• Confident work with Binance or Bybit
• First conscious trades
• Reading candlestick charts and trends
• Basic portfolio allocation

Course Program:
1. Wallet types: hot, cold, custodial
2. Working with an exchange: deposit, withdrawal, orders
3. Market and limit orders in practice
4. Technical analysis basics: candles and trends
5. Stablecoins and their role in a portfolio
6. Protection from scams and fraudsters
7. Beginner portfolio: proportions and risks
8. Action plan for your first month`,
        features: [
          'Practical assignments',
          'Analysis of common mistakes'
        ]
      },
      {
        id: 1,
        name: 'Crypto Starter',
        price: 300,
        level: 'beginner',
        duration: '2 weeks',
        practice: '10 hours',
        description: 'Your first step into the world of cryptocurrency. Perfect for those who want to understand the basics without complex terminology.',
        fullDescription: `Welcome to the world of cryptocurrency! The Crypto Starter course is specifically designed for those who are just beginning their journey in digital assets.

What you will get:
• Complete understanding of blockchain technology from scratch
• Confident work with crypto exchanges and wallets
• First trades without fear and risk
• Protection from scams and fraudsters
• Basic market analysis

Course Program:
1. Introduction to Cryptocurrencies - history, blockchain principles
2. Types of Cryptocurrencies - Bitcoin, Ethereum, altcoins, stablecoins
3. Creating and Securing Wallets - hardware, software, online
4. Working with Exchanges - Binance, Bybit, OKX step by step
5. First Crypto Purchase - from registration to first coin
6. Basic Security - 2FA, seed phrases, cold storage
7. Reading Charts and Candles - technical analysis basics
8. Investor Psychology - how not to sell in panic
9. Beginner Portfolio - basic asset allocation
10. Success and Failure Cases - real student stories`,
        features: [
          'Real trade analysis',
          'Updates on new trends'
        ]
      },
      {
        id: 12,
        name: 'Spot Strategist',
        price: 400,
        level: 'intermediate',
        duration: '3 weeks',
        practice: '18 hours',
        description: 'Spot trading without leverage: planned entries, position management, and a portfolio for real markets.',
        fullDescription: `Spot Strategist is for those who already bought their first crypto and want to trade consciously — without leverage and unnecessary noise.

You will learn to build simple spot strategies, size risk per trade, and assemble a portfolio for your horizon.

What you will get:
• A clear spot entry and exit algorithm
• Working with levels, volume, and news catalysts
• Position-sizing rules without overtrading
• Portfolio construction and rebalancing
• Checklists before every trade

Course Program:
1. Spot vs futures — when spot is enough
2. Trade structure: setup, entry, stop, take-profit
3. Levels and interest zones in practice
4. Volume and liquidity: how not to buy into thin air
5. News and catalysts without FOMO
6. Portfolio: core, satellites, stablecoin cash
7. Trade journal and mistake review
8. 30-day plan after the course`,
        features: [
          'Trading plan templates',
          'Spot setup reviews'
        ]
      },
      {
        id: 2,
        name: 'Smart Trader',
        price: 500,
        level: 'intermediate',
        duration: '1 month',
        practice: '25 hours',
        description: 'A systematic approach to trading. Strategies reinforced through practice, not theory.',
        fullDescription: `Smart Trader is a course for those who want to learn active and systematic cryptocurrency trading.

We don't sell the "holy grail" - we teach discipline, analysis, and risk management. Every strategy has been tested on real markets.

What you will learn:
• Read the market like a professional
• Use 5+ working trading strategies
• Manage capital and risks
• Control emotions while trading
• Create your own trading plans

Course Program:
1. Advanced Technical Analysis
   - All patterns and figures
   - Support/resistance levels
   - Trend channels and lines
   - Wave analysis (basics)
   
2. Indicators and Oscillators
   - RSI, MACD, Stochastic
   - Volume indicators
   - Settings for different timeframes
   - Combining indicators
   
3. Candlestick Analysis
   - All significant patterns
   - Pin bars, engulfing, doji
   - Candle combinations
   - False breakouts
   
4. Trading Strategies
   - Breakout strategy
   - Counter-trend strategy
   - Scalping (short-term)
   - Swing trading (medium-term)
   - News-based strategy
   
5. Risk Management
   - Position calculation
   - Stop-losses and take-profits
   - Risk/reward ratio
   - Diversification
   
6. Trading Psychology
   - Trade planning
   - Trader journal keeping
   - Working with fear and greed
   - Recovery after drawdowns`,
        features: [
          'Strategy library',
          'Individual calls'
        ]
      },
      {
        id: 3,
        name: 'DeFi Investor',
        price: 700,
        level: 'advanced',
        duration: '6 weeks',
        practice: '40 hours',
        description: 'Deep dive into decentralized finance. Staking, liquidity pools, yield farming, and more.',
        fullDescription: `DeFi Investor - a complete immersion into the world of decentralized finance. Here you will learn how DeFi protocols work and how to use them responsibly.

DeFi is a complex and fast-changing field that requires deep knowledge. This course is your map in the world of decentralization.

What you will master:
• Working with DeFi protocols at a professional level
• Protocol analysis and risk assessment
• Minimizing risks (impermanent loss, hacks)
• Developing your own DeFi strategies
• Optimizing gas fees

Course Program:
1. DeFi Basics
   - What are smart contracts
   - How DEXs work
   - Token types: ERC-20, BEP-20, etc.
   - Blockchains for DeFi: Ethereum, BSC, Polygon, Arbitrum
   
2. Working with DEX
   - Uniswap, PancakeSwap, 1inch
   - Swaps and routing
   - Limit orders on DEX
   - Liquidity aggregators
   
3. Liquidity Pools
   - How AMMs work
   - Impermanent loss - calculation and protection
   - Choosing optimal pools
   - Two-sided and one-sided pools
   
4. Staking and Farming
   - Types of staking
   - Yield farming
   - Restaking via EigenLayer
   - Autocompounding
   
5. Yield Strategies
   - Delta-neutral strategy
   - Arbitrage between DEXs
   - Volatility strategy
   - Multichain farming
   
6. Analysis Tools
   - DeFi Llama, DeBank
   - TVL and metrics analysis
   - Checking contract audits
   - Tracking whales
   
7. Security in DeFi
   - Recognizing scam projects
   - Revoking approvals
   - Multisig wallets
   - Position insurance (Nexus Mutual)
   
8. Taxes and Accounting
   - Tracking transactions
   - Tax optimization
   - Tools: CoinTracker, Koinly`,
        features: [
          'New protocol analysis',
          'Individual strategy for your capital',
          'Updates on new trends'
        ]
      },
      {
        id: 4,
        name: 'Futures Master',
        price: 800,
        level: 'professional',
        duration: '2 months',
        practice: '60 hours',
        description: 'Futures trading and margin trading. Leverage as a tool, not a toy.',
        fullDescription: `Futures Master - a course for serious traders who want to master leveraged trading at a professional level.

Futures allow you to trade in different market conditions and use leverage — but require iron discipline.

Why this course:
• Learning through real trades, not theory
• Risk management as the main priority
• Psychological preparation for high stakes
• Automation of trading processes

Course Program:
1. Futures Basics
   - What are futures and perpetuals
   - Margin trading
   - Funding and funding rate
   - Order types: limit, market, stop
   
2. Working with Leverage
   - Isolation vs Cross margin
   - Calculating effective leverage
   - Managing margin calls
   - Optimal leverage for different strategies
   
3. Long/Short Strategies
   - Trend strategies with leverage
   - Counter-trend on futures
   - Spot-futures arbitrage
   - Basis trading
   
4. Liquidation Analysis
   - Liquidation maps
   - Liquidity traps
   - Trading against the crowd
   - Crowd position indicators
   
5. Risk Management
   - Position calculation formula
   - Cascade stops
   - Hedging spot positions
   - Correlation risks
   
6. Algorithmization
   - Trading bots: basics
   - Grid trading
   - DCA bots on futures
   - Arbitrage bots
   
7. Leverage Psychology
   - Working with greed
   - Recovery after liquidation
   - Position size and emotions
   - Trading plan for leverage`,
        features: [
          'Trading signals',
          'Priority support'
        ]
      },
      {
        id: 5,
        name: 'Whale Analyst',
        price: 1000,
        level: 'elite',
        duration: '3 months',
        practice: '80 hours',
        description: 'Deep on-chain analysis. Tracking smart money, whale analytics, predictive models.',
        fullDescription: `Whale Analyst - a course for those who want to see through the market. On-chain analytics allows you to follow smart money and anticipate market movements.

You will use the same tools as the largest funds and crypto whales in the industry.

What is included in the program:
• Complete on-chain analysis from zero to pro
• Working with Glassnode, Nansen, Arkham
• Tracking whale wallets
• Creating predictive models
• Macro indicators analysis

Detailed Program:
1. Blockchain Explorers
   - Etherscan, BscScan, Solscan
   - Reading transactions
   - Smart contract analysis
   - Tracking flows
   
2. On-Chain Analytics Platforms
   - Glassnode: all metrics
   - CryptoQuant: professional work
   - Nansen: smart money
   - Arkham: wallet de-anonymization
   - Santiment: behavioral analysis
   
3. Metrics and Indicators
   - MVRV, NUPL, SOPR
   - Exchange reserves analysis
   - Long-term holders
   - Miner flows
   - Staking outflows
   
4. Whale Analysis
   - Identifying major players
   - Wallet tracking
   - Correlation with price
   - Smart Money Concepts
   
5. Social Analysis
   - Social media sentiment
   - Twitter/Discord analytics
   - Fear and greed
   - Trending words and hashtags
   
6. Macro Analysis
   - Correlation with traditional market
   - Fed and inflation data
   - ETF flows
   - Geopolitical factors
   
7. Practical Application
   - Creating dashboards
   - Automatic alerts
   - Investor reports
   - TradingView integration`,
        features: [
          'Analysis templates',
          'Insider information',
          'Early access to analysis'
        ]
      },
      {
        id: 6,
        name: 'Altcoin Hunter',
        price: 1500,
        level: 'master',
        duration: '4 months',
        practice: '100 hours',
        description: 'Finding promising altcoins before they take off. Fundamental analysis, tokenomics, vesting.',
        fullDescription: `Altcoin Hunter - a course for hunters of crypto market gems. Learn to find projects before the crowd hears about them.

We reveal the methodology for finding alpha that crypto funds with billion-dollar capitalizations use.

What you will learn:
• Fundamental analysis of crypto assets
• Tokenomics and vesting evaluation
• Team and investor analysis
• Early access to IDO/IEO/ICO
• Altcoin portfolio diversification

Detailed Program:
1. Fundamental Analysis
   - Whitepaper: what to look for
   - Technology evaluation
   - Competitive analysis
   - Product-market fit
   
2. Tokenomics
   - Token distribution
   - Vesting and unlocks
   - Inflation and deflation
   - Token utility
   - Tokenomic models
   
3. Team and Investors
   - Team due diligence
   - Expertise verification
   - Investor analysis (VC)
   - Advisory board
   - Partnerships
   
4. Project Metrics
   - TVL and its dynamics
   - Development activity (GitHub)
   - Social metrics
   - On-chain activity
   - Comparative analysis
   
5. Early-stage Projects
   - IDO platforms
   - Exchange IEOs
   - Seed and Private rounds
   - Participation strategy
   - Whitelist strategies
   
6. Crypto Sectors
   - L1 and L2 solutions
   - DeFi 2.0 and 3.0
   - GameFi and metaverses
   - RWA (real world assets)
   - AI and crypto
   - Memecoins as indicator
   
7. Portfolio Management
   - Sector balancing
   - Project growth stages
   - Profit taking
   - Rebalancing
   
8. Risk Analysis
   - Regulatory risks
   - Technical risks
   - Team risks
   - Market risks`,
        features: [
          'Analysis templates',
          'Insider information',
          'Early access to analysis'
        ]
      },
      {
        id: 7,
        name: 'NFT & Metaverse Pro',
        price: 2000,
        level: 'guru',
        duration: '5 months',
        practice: '120 hours',
        description: 'The world of NFTs, metaverses and GameFi. Collecting, flipping, creating collections, P2E games.',
        fullDescription: `NFT & Metaverse Pro - a complete immersion into the world of non-fungible tokens, metaverses and blockchain games.

This is not just monkey pictures — this is a new economy of digital ownership with its own rules and tools.

What you will master:
• Professional NFT trading
• Creating successful collections
• Working with metaverses
• GameFi and P2E strategies
• Owning digital real estate

Detailed Program:
1. NFT World
   - NFT technology in depth
   - Standards: ERC-721, ERC-1155, etc.
   - Markets: OpenSea, Blur, Magic Eden
   - History and evolution of NFTs
   
2. NFT Trading
   - Flipping strategies
   - Rarity and traits analysis
   - Trends and memes
   - Working with gas (gas wars)
   - Sniping rare NFTs
   
3. Collecting
   - Blue chip collections
   - Long-term value assessment
   - Utility and rights
   - IP and commercial use
   
4. Creating Collections
   - Art generation
   - Smart contracts for NFTs
   - Launch strategies
   - Collection marketing
   - Community building
   
5. Metaverses
   - Decentraland, Sandbox, Otherside
   - Buying and developing land
   - Metaverse monetization
   - Events and business in metaverses
   
6. GameFi
   - Blockchain game economics
   - P2E models
   - Top games and strategies
   - Studying game tokens
   - Guilds and scholarships
   
7. Tools
   - NFT analytics
   - Whale tracking
   - Rarity.tools and alternatives
   - Purchase automation
   
8. Legal Aspects
   - Copyright on NFTs
   - NFT taxes
   - Contracts and agreements`,
        features: [
          'Insider analytics',
          'Special community status'
        ]
      },
      {
        id: 8,
        name: 'Crypto Empire',
        price: 2500,
        level: 'legend',
        duration: '6 months',
        practice: '150 hours',
        description: 'Comprehensive program for building a crypto empire. All directions, automation, team, scaling.',
        fullDescription: `Crypto Empire is a comprehensive program for those who want to master the crypto industry at a professional level.

Here you will study all key areas: trading, DeFi, NFT, content creation, and consulting.

This program is for those who want to:
• Build a systematic approach to working with crypto assets
• Master capital and risk management
• Build a team and automate processes
• Become an authority in the crypto industry

The program includes ALL previous courses plus an exclusive module:

1. Master Program (all platform courses)
2. Exclusive Crypto Empire Module:

   Block 1: Capital Management
   - Managing 8-9 figure sums
   - Asset structuring
   - Offshore planning
   - Crypto asset inheritance
   
   Block 2: Building Working Systems
   - Building mining farms
   - Nodes and validators
   - Turnkey crypto business
   - Creating fund/DAO
   
   Block 3: Automation
   - Trading algorithms
   - Automatic DeFi strategies
   - Bots for all directions
   - Exchange API integration
   
   Block 4: Team Management
   - Hiring analysts and traders
   - Task delegation
   - Creating management system
   - Scaling operations
   
   Block 5: Personal Brand
   - Expert positioning
   - Content strategy
   - Audience growth
   - Influence monetization
   
   Block 6: Networking
   - Closed events
   - Fund connections
   - Insider information
   - Strategic partnerships
   
   Block 7: Future of Crypto
   - Regulatory evolution
   - Institutional adoption
   - New technologies (ZK, L3)
   - Preparation for bull market

Special Conditions:
• Personal meeting with founder
• Weekly 1-on-1 calls
• Access to all closed channels
• Priority in any projects
• 12 months of support`,
        features: [
          'ALL Courses + Exclusive',
          'Priority forever'
        ]
      },
      {
        id: 9,
        name: 'VIP Mentorship',
        price: 3000,
        level: 'legend',
        duration: '12 months',
        practice: 'Unlimited',
        description: 'Personal mentorship from the founder of RedLevelCrypto. Full support, private meetings, insider access.',
        fullDescription: `VIP Mentorship - an exclusive program of personal support from the founder of RedLevelCrypto.

This is not a course in the usual sense. This is a full partnership where you get direct access to top-level thinking and strategies.

Only 10 spots per year.

What's included:
• Weekly personal calls
• Access to closed deals
• Joint decision making
• Help in crisis situations
• Top-level networking

Format:
1. Strategy Sessions (2 hours/week)
   - Your portfolio analysis
   - Action planning
   - Strategy adjustment
   - Psychological support
   
2. Operational Connection
   - Telegram/WhatsApp 24/7
   - Response within an hour
   - Emergency consultations
   - Voice analysis
   
3. Exclusive Access
   - Access to private sales
   - Early information access
   - Meetings with project founders
   - Participation in closed rounds
   
4. Events
   - Quarterly personal meetings
   - Access to VIP events
   - Conferences and summits
   - Private parties
   
5. Resources
   - Full access to all materials
   - Individual research
   - Personal tools
   - Priority in new directions

Result:
Deeper market understanding and development of your own decision-making system.

Candidate Requirements:
• Willingness to intensive work
• Minimum capital $100k+
• Clean reputation in the industry
• Long-term thinking

Mandatory interview before starting.`,
        features: [
          'All platform resources',
          'Maximum priority'
        ]
      }
    ]
  },
  features: {
    title: 'Why Choose Us',
    items: [
      {
        title: 'Practical Skills',
        description: 'Programs are built on real case studies and practical assignments, not abstract theory.',
        icon: 'TrendingUp'
      },
      {
        title: 'Top Experts',
        description: 'Training is conducted by practicing traders with 2+ years of market experience.',
        icon: 'Users'
      },
      {
        title: 'Up-to-Date Knowledge',
        description: 'Courses are updated monthly. You always receive the freshest market information.',
        icon: 'RefreshCw'
      },
      {
        title: 'Community',
        description: 'Telegram chat with like-minded people and insider information.',
        icon: 'MessageCircle'
      },
      {
        title: 'Practice',
        description: 'Over 70% of the time is practical assignments and market analysis, not dry theory.',
        icon: 'Target'
      },
      {
        title: 'Online Support',
        description: 'Our curators answer questions at any time of day or night.',
        icon: 'Headphones'
      }
    ]
  },
  about: {
    title: 'About RedLevelCrypto',
    subtitle: 'We are located in the Republic of Belarus',
    description: `RedLevelCrypto is a premium educational platform for studying cryptocurrency, trading, and blockchain technology.

We are located in the Republic of Belarus. In Belarus, cryptocurrencies are fully legalized — you can buy, sell, store, and use digital assets within the current legal framework.

Our mission is to give students practical knowledge and skills for working with the crypto market. We do not promise quick results and do not sell "secret strategies." We teach analysis, thinking, and making balanced decisions.

Since 2024, we have trained over 150 students. Our graduates work in top crypto funds, manage their own funds or trade on their own capital.

What sets us apart:
• Only practicing instructors
• Updated materials
• Live support
• Real results
• Community of professionals`,
    stats: [
      { value: '150+', label: 'Graduates' },
      { value: '12+', label: 'Educational Programs' },
      { value: '2', label: 'Years in Market' },
      { value: 'BY', label: 'Legal Business' }
    ]
  },
  faq: {
    title: 'Frequently Asked Questions',
    items: [
      {
        question: 'Which course should a beginner start with?',
        answer: 'For absolute beginners on a tight budget, we recommend Crypto Intro ($100) or Crypto Base ($200). For a full start — Crypto Starter ($300). If you already have basic knowledge and want to trade immediately — Smart Trader ($500).'
      },
      {
        question: 'Are there installment plans or discounts?',
        answer: 'No, we do not provide installment plans. Payment is available with any card in the world.'
      },
      {
        question: 'How long is the course available after purchase?',
        answer: 'All courses are provided with lifetime access, including all future updates. VIP Mentorship has a limited duration (12 months).'
      },
      {
        question: 'Do I need a large starting capital?',
        answer: 'No, many of our students started with $100-500. The main thing is knowledge and discipline. Of course, the larger the capital, the faster the scaling.'
      },
      {
        question: 'Is there support after the course?',
        answer: 'Yes, access to closed communities is maintained forever. Also for graduates there are special channels with analytics and market analysis.'
      }
    ]
  },
  courseDetail: {
    notFound: 'Course not found',
    backHome: 'Back to home',
    allCourses: 'All courses',
    specs: 'Course details',
    description: 'Course description',
    includes: "What's included",
    features: 'Features',
    readyTitle: 'Ready to start learning?',
    readySubtitle: 'Join {{name}} and start structured learning',
    buyFor: 'Buy course for ${{price}}',
    paymentNote: 'Payment available with any card worldwide',
    paymentBadge: 'Pay with any card worldwide'
  },
  telegramModal: {
    title: 'Join us',
    description:
      'To purchase a course or get a consultation, message us on Telegram. Our managers will reply within 15 minutes.',
    cta: 'Message on Telegram',
    emailNote: 'Or email us at: redlevelsupport@icloud.com'
  },
  buyModal: {
    title: 'Buy a course',
    text: 'To buy a course, email us or message us on Telegram — or leave a callback request.',
    writeTelegram: 'Message on Telegram',
    writeEmail: 'Send an email',
    callback: 'Leave a callback request',
    takeTest: 'Not sure about your choice? Take the free quiz',
    close: 'Close'
  },
  contactForm: {
    title: 'We’ll match you with a course',
    subtitle: 'Leave your name and take a short quiz — we’ll recommend a program for your budget.',
    callbackTitle: 'Callback request',
    callbackSubtitle: 'Leave your contacts — we’ll get in touch and help you purchase the course.',
    nameLabel: 'Name',
    namePlaceholder: 'How should we address you?',
    emailLabel: 'Email',
    emailPlaceholder: 'you@email.com',
    telegramLabel: 'Telegram',
    telegramPlaceholder: '@username',
    required: 'This field is required',
    invalidEmail: 'Enter a valid email',
    invalidTelegram: 'Enter Telegram as @username',
    startQuiz: 'Start the quiz',
    next: 'Next',
    back: 'Back',
    submit: 'Submit request',
    submitting: 'Sending...',
    successTitle: 'Request sent',
    successText: 'We’ll get in touch shortly to confirm your course.',
    error: 'Could not send. Try again or contact us directly.',
    matchTitle: 'Course matched to your budget',
    matchSubtitle: 'Leave your contacts — a manager will help you enroll in the recommended program.',
    recommendedLabel: 'We recommend',
    recommendedPrice: '${{price}}',
    quizIntro: '5 short questions',
    questionOf: 'Question {{current}} of {{total}}',
    writeTelegram: 'Message us on Telegram',
    writeEmail: 'Send an email',
    orDirect: 'Or contact us directly',
    close: 'Close',
    questions: [
      {
        q: 'What is your crypto experience?',
        options: [
          'Just getting started',
          'I have basic knowledge',
          'I trade on my own',
          'Professional level'
        ]
      },
      {
        q: 'What is your main goal?',
        options: [
          'Understand the market basics',
          'Learn systematic trading',
          'Invest long term',
          'Personal mentorship'
        ]
      },
      {
        q: 'How much time can you spend learning each week?',
        options: ['2–4 hours', '5–10 hours', '10–20 hours', 'As much as possible']
      },
      {
        q: 'What course budget are you considering?',
        options: [
          'Up to $200',
          '$300–$400',
          '$500–$700',
          '$800–$1000',
          '$1500–$2000',
          '$2500+'
        ]
      },
      {
        q: 'What interests you most?',
        options: [
          'Spot trading',
          'Futures and leverage',
          'DeFi and investing',
          'Full personal support'
        ]
      }
    ]
  },
  promo: {
    code: 'SALE50',
    discount: '50',
    welcomeTitle: 'New user discount',
    welcomeText: 'Get $50 off your first purchase of any course with promo code SALE50.',
    copy: 'Copy code',
    copied: 'Copied',
    close: 'Close',
    stickyText: '−$50 on first course',
    stickyCode: 'SALE50'
  },
  cta: {
    title: 'Ready to start learning?',
    subtitle: 'Join 150+ RedLevelCrypto students',
    button: 'Start Learning'
  },
  footer: {
    description: 'Premium education in cryptocurrency, trading, and blockchain technology.',
    legal: 'Legal Information',
    links: {
      courses: 'Courses',
      about: 'About',
      faq: 'FAQ',
      contact: 'Contact',
      privacy: 'Privacy Policy',
      terms: 'Terms of Use'
    },
    contact: {
      email: 'redlevelsupport@icloud.com',
      telegram: '@RedLevelCrypto',
      support: 'Online Support'
    },
    rights: '© 2024-2026 RedLevelCrypto. All rights reserved.',
    operator: {
      name: 'Novik Beata Sergeevna',
      taxId: 'UNP: НЕ7424414',
      address:
        'Registered address: Republic of Belarus, Grodno region, Oshmyany district, Oshmyany, Mitskevicha Street, 51'
    }
  },
  buyMonecle: {
    badge: 'Payment',
    title: 'Course payment',
    subtitle: 'Choose a currency and amount. You will be redirected to the secure Monecle checkout.',
    currency: 'Payment currency',
    usd: 'USD $',
    eur: 'EUR €',
    pay: 'Pay',
    secure: 'Secure card payment via Monecle',
    backHome: 'Back home',
    fallbackName: 'Course'
  }
};
